import { Flex } from '@chakra-ui/react';
import { useSearchParams } from 'react-router';
import FilterTag from '@components/FilterTag';
import useGetPortfolio from '@hooks/useGetPortfolio';

const SelectedFiltersList = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const name = searchParams.get('name');
  const portfolioId = searchParams.get('portfolioId');

  const { portfolio } = useGetPortfolio({ portfolioId });

  const onRemoveFilter = (key: string) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.delete(key);
    setSearchParams(newParams);
  };

  return (
    <Flex gap={2}>
      {name && (
        <FilterTag
          label="Nome"
          value={name}
          onRemove={() => onRemoveFilter('name')}
        />
      )}
      {portfolio && portfolioId && (
        <FilterTag
          label="Portfólio"
          value={portfolio.name}
          onRemove={() => onRemoveFilter('portfolioId')}
        />
      )}
    </Flex>
  );
};

export default SelectedFiltersList;
